import React from "react";
import PropTypes from "prop-types";
import { Row, Col,
    // Card, Select, Button 
} from "antd";
import QuestionareList from "./questionare-list";
import PDToLOSView from "./pd-to-los-view";
import {
    updateCaseQuestionnaire,
    downloadCaseQuestionnaire,
    updateCaseDetail,
    updateChannelProductStats
} from "store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
 
class WelcomeCallQuestionareTab extends React.Component {
    state = {
        selectedRelationshipManager: null
    };

    downloadPDF= (data) => {
        this.props.downloadCaseQuestionnaire(this.props.caseId, data);
    }

    render() {
        return (
            <Row className={"p-5"}>
                <Col offset={3} span={18} className={"p-10"}>
                    <QuestionareList 
                        questionare={this.props.questionare}
                        companyId={this.props.companyId}
                        updateCaseQuestionnaire={this.props.updateCaseQuestionnaire.bind(null, this.props.caseId)}
                        userId={this.props.userId}
                        caseId={this.props.caseId}
                        caseData={this.props.caseData}
                        caseDetail={this.props.caseDetail}
                        downloadPDF={this.downloadPDF}
                        updateChannelProductStats={this.props.updateChannelProductStats}
                        updateCaseDetail={this.props.updateCaseDetail}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    />
                </Col>
                <Col offset={3} span={18} className={"p-10"}>
                    <PDToLOSView
                        caseDetail={this.props.caseDetail}
                        updateChannelProductStats={this.props.updateChannelProductStats}
                        updateCaseDetail={this.props.updateCaseDetail}
                        caseId={this.props.caseId}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    />
                </Col>
            </Row>
        );
    }
}

WelcomeCallQuestionareTab.propTypes = {
    history: PropTypes.object,
    sales_manager: PropTypes.array,
    questions: PropTypes.array,
    questionare: PropTypes.array,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    updateCaseQuestionnaire: PropTypes.func,
    downloadCaseQuestionnaire: PropTypes.func,
    userId: PropTypes.number,
    caseData: PropTypes.object,
    updateCaseDetail: PropTypes.func,
    caseDetail: PropTypes.object,
    updateChannelProductStats: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    return {
        userId: state.user.getIn(["data", "id"]),
        questionare: state.caseDetails.getIn([props.caseId, "data", "questionnaire"])
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        updateCaseQuestionnaire,
        downloadCaseQuestionnaire,
        updateCaseDetail,
        updateChannelProductStats
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeCallQuestionareTab);